import { Button, Row } from 'antd';
import ButtonWithSpinner from 'components/common/ButtonWithSpinner';
import styled from 'styled-components';

export const ButtonContainerStyled = styled.div`
  margin-top: 10px;
`;

export const CancelButtonStyled = styled(Button)`
  background-color: #e0e0e0;
  border: none;
  &:hover,
  &:focus {
    opacity: 0.8;
    background-color: #e0e0e0;
    color: initial;
  }
`;

export const ActionButtonStyled = styled(ButtonWithSpinner)`
  min-width: 100px;
  &:hover,
  &:focus {
    opacity: 0.8;
  }
`;

export const AddIconStyled = styled.span`
  font-weight: 400;
  font-size: 20px;
  margin-right: 5px;
`;

export const InviteButtonContainerStyled = styled(Row)`
  margin: 0;
  flex-wrap: nowrap;
`;
